import { CompanyRevenueDtoPeriodEnum } from '@@types/api.types';
import { withForm } from '@components/ui/form/form';
import { FormErrorMessage, FormField, FormLabel } from '@components/ui/form/shared.component';
import { Input } from '@components/ui/input';
import { ChangeEvent } from 'react';
import { companyFormOptions } from './company-form-options';

const handleCurrencyChange = (field: { handleChange: (value: any) => void }, event: ChangeEvent<HTMLInputElement>) => {
  const inputValue = event.target.value.replace(/,/g, '');

  if (inputValue === '') {
    field.handleChange('');
    return;
  }

  const cleanedValue = inputValue.trim();

  // Prevent storing a lone decimal point which later coerces to NaN
  if (cleanedValue === '.') {
    field.handleChange('0.');
    return;
  }

  const decimalPattern = /^\d*(?:\.\d{0,2})?$/;
  if (!decimalPattern.test(cleanedValue)) {
    return;
  }

  field.handleChange(cleanedValue);
};

export const FinancialStep = withForm({
  ...companyFormOptions,
  render: function Render({ form }) {
    const revenuePeriodOptions = Object.values(CompanyRevenueDtoPeriodEnum).map((value) => ({
      label: value,
      value,
    }));

    return (
      <form.AppForm>
        <div className="flex w-full flex-col items-start gap-6">
          <div className="flex w-full flex-row items-start gap-4">
            <form.AppField name="revenue.amount">
              {(field) => (
                <FormField className="flex-1">
                  <FormLabel>Current Revenue</FormLabel>
                  <div className="relative w-full">
                    <Input
                      inputMode="decimal"
                      className="flex h-10 w-full rounded-lg bg-gray-100 p-3 pl-6 pr-12"
                      id={field.name}
                      name={field.name}
                      onBlur={field.handleBlur}
                      onChange={(event) => handleCurrencyChange(field, event)}
                      value={
                        field.state.value === undefined || field.state.value === null ? '' : String(field.state.value)
                      }
                    />
                    <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                      $
                    </span>
                    <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
                      USD
                    </span>
                  </div>
                  <FormErrorMessage />
                </FormField>
              )}
            </form.AppField>

            <form.AppField name="revenue.period">
              {(field) => (
                <field.SelectField
                  className="w-[200px]"
                  label="Period"
                  options={revenuePeriodOptions}
                  placeholder="Select"
                />
              )}
            </form.AppField>
          </div>

          <form.AppField name="revenue.valuation">
            {(field) => (
              <FormField className="w-full">
                <FormLabel>Current Valuation</FormLabel>
                <div className="relative w-full">
                  <Input
                    inputMode="decimal"
                    className="flex h-10 w-full rounded-lg bg-gray-100 p-3 pl-6 pr-12"
                    id={field.name}
                    name={field.name}
                    onBlur={field.handleBlur}
                    onChange={(event) => handleCurrencyChange(field, event)}
                    value={
                      field.state.value === undefined || field.state.value === null ? '' : String(field.state.value)
                    }
                  />
                  <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
                  <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
                    USD
                  </span>
                </div>
                <FormErrorMessage />
              </FormField>
            )}
          </form.AppField>
        </div>
      </form.AppForm>
    );
  },
});
